import { IdentityVerificationStatus } from '@blockpulse3/graphql/hooks';

export interface getVerificationStatusBadgeContentOutput {
  color: string;
  translationKey: 'Approved' | 'None' | 'Pending' | 'Refused';
}

enum VerificationStatusBadgeColor {
  APPROVED = 'green',
  NONE = 'gray',
  PENDING = 'yellow',
  REFUSED = 'red',
}

enum VerificationStatusTranslationKey {
  APPROVED = 'Approved',
  NONE = 'None',
  PENDING = 'Pending',
  REFUSED = 'Refused',
}

export const getVerificationStatusBadgeContent = (
  status: IdentityVerificationStatus,
): getVerificationStatusBadgeContentOutput => {
  switch (status) {
    case IdentityVerificationStatus.APPROVED:
      return {
        color: VerificationStatusBadgeColor[IdentityVerificationStatus.APPROVED],
        translationKey: VerificationStatusTranslationKey[IdentityVerificationStatus.APPROVED],
      };

    case IdentityVerificationStatus.REFUSED:
      return {
        color: VerificationStatusBadgeColor[IdentityVerificationStatus.REFUSED],
        translationKey: VerificationStatusTranslationKey[IdentityVerificationStatus.REFUSED],
      };

    case IdentityVerificationStatus.PENDING:
      return {
        color: VerificationStatusBadgeColor[IdentityVerificationStatus.PENDING],
        translationKey: VerificationStatusTranslationKey[IdentityVerificationStatus.PENDING],
      };

    case IdentityVerificationStatus.NONE:
    default:
      return {
        color: VerificationStatusBadgeColor[IdentityVerificationStatus.NONE],
        translationKey: VerificationStatusTranslationKey[IdentityVerificationStatus.NONE],
      };
  }
};
